import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  limit: 11,
  totalPage: 2,

  pageInfo: {},

  detail: {},
  list: [],

  event: {
    page: 1,
    limit: 11,
    totalPage: 2,
    content: {
      eventNo: 0,
      titleKr: '',
      titleVn: '',
      contentKr: '',
      contentVn: '',
      regDate: ''
    },
    list: []
  },

  notice: {
    page: 1,
    limit: 10,
    totalPage: 2,
    content: {},
    list: []
  },

  faq: {
    page: 1,
    limit: 10,
    totalPage: 2,
    content: {},
    list: []
  },

  inquiry: {
    page: 1,
    limit: 10,
    totalPage: 2,
    content: {},
    list: []
  },

  adminNotice: {
    page: 1,
    limit: 10,
    totalPage: 2,
    content: {},
    list: []
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
